import { actionService } from '../services'
import { emailTemplateModule } from './email-template.module'

const state = {
    all: {
        loading: false,
        rows: []
    },
    loading: false
}

const actions = {

    getAll ({ dispatch, commit }, params) {
        commit('getAllRequest')
        actionService.getAll(params).then(
            response => {
                commit('getAllSuccess', response)
            }
        )
    },

    update({ dispatch, commit }, params) {
        commit('startRequest')
        return actionService.update(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Your changes have been saved.', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },
    restoreDefaultTemplatesAndAction({ dispatch, commit }, params) {
        commit('startRequest')
        actionService.restoreDefaultTemplatesAndAction(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Action updated successfully', { root: true })
                dispatch('emailTemplateModule/getAll', '', { root: true })
                dispatch('getAll')
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },
    restoreDefaultTemplateForAction({ dispatch, commit }, params) {
        commit('startRequest')
        actionService.restoreDefaultTemplateForAction(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Action template restored successfully', { root: true })
                dispatch('emailTemplateModule/getAll', '', { root: true })
                dispatch('getAll')
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },
    updateTierTemplate({ dispatch, commit }, params) {
        commit('startRequest')
        actionService.updateTierTemplate(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Your changes have been saved.', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action', { root: true })
            }
        )
    },
    get({ dispatch, commit }, name) {
        commit('startRequest')
        return actionService.retrieve(name).then(
            response => {
                commit('endRequest')
                return response
            },
            error => {
                commit('endRequest')
            }
        )
    },
    updateTemplateOffer({ dispatch, commit }, params) {
        commit('startRequest')
        actionService.updateTemplateOffer(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Your changes have been saved.', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action', { root: true })
            }
        )
    },

}

const mutations = {
    getAllRequest (state, params) {
        state.all = { loading: true, rows: [] }
    },
    getAllSuccess (state, data) {
        state.all = { loading: false, rows: data.rows }
    },
    startRequest (state) {
        state.all.loading = true
    },
    endRequest (state) {
        state.all.loading = false
    },
}

const getters = {
    isLoadingActions (state) {
        return state.all.loading === true
    },
    getActions (state) {
        return state.all.rows
    },
}

export const actionModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
